import _objectWithoutProperties from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _get from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import classnames from 'classnames';
import config, { isRTL } from '../config';
import { PureComponent } from '../component';
import { inputClass } from '../Input/styles';
import cleanProps from '../utils/cleanProps';
import InputTitle from '../InputTitle';
import { inputTitleClass } from '../InputTitle/styles';
var DefaultProps = {
  rows: 4,
  resize: false
};

var Textarea =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Textarea, _PureComponent);

  var _super = _createSuper2(Textarea);

  function Textarea(props) {
    var _this;

    _classCallCheck(this, Textarea);

    _this = _super.call(this, props);
    _this.shadow = void 0;

    _this.defaultInfo = function (value) {
      if (!value || value.length === 0) return null;
      var info = _this.props.info;
      var text = "".concat(value.length, " / ").concat(info);
      if (value.length <= info) return text;
      return new Error(text);
    };

    _this.state = {
      height: 0
    };
    _this.bindShadow = _this.bindShadow.bind(_assertThisInitialized(_this));
    _this.handleBlur = _this.handleBlur.bind(_assertThisInitialized(_this));
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    _this.handleKeyUp = _this.handleKeyUp.bind(_assertThisInitialized(_this));
    _this.resize = _this.resize.bind(_assertThisInitialized(_this));
    _this.defaultInfo = _this.defaultInfo.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Textarea, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      _get(_getPrototypeOf(Textarea.prototype), "componentDidMount", this).call(this);

      if (this.props.autosize) this.resize();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.autosize && prevProps.value !== this.props.value) this.resize(this.props.value);
    }
  }, {
    key: "getTrim",
    value: function getTrim() {
      var trim = this.props.trim;
      if (trim !== undefined) return trim;
      if (config.trim !== undefined) return config.trim;
      return false;
    }
  }, {
    key: "bindShadow",
    value: function bindShadow(el) {
      this.shadow = el;
    }
  }, {
    key: "resize",
    value: function resize(value) {
      if (value || value === '') this.shadow.value = value;
      var height = this.shadow ? this.shadow.scrollHeight : 0;
      this.setState({
        height: height
      });
    }
  }, {
    key: "handleChange",
    value: function handleChange(e) {
      this.props.onChange(e.target.value);

      if (this.props.autosize) {
        this.resize(e.target.value);
      }
    }
  }, {
    key: "handleKeyUp",
    value: function handleKeyUp(e) {
      var onEnterPress = this.props.onEnterPress;

      if (e.keyCode === 13 && onEnterPress) {
        onEnterPress(e.target.value, e);
      }
    }
  }, {
    key: "handleBlur",
    value: function handleBlur(e) {
      var newValue = e.target.value;
      var _this$props = this.props,
          forceChange = _this$props.forceChange,
          onBlur = _this$props.onBlur;

      if (this.getTrim()) {
        newValue = newValue.trim();
        e.target.value = newValue;
      }

      forceChange(newValue);
      if (onBlur) onBlur(e);
    }
  }, {
    key: "renderFooter",
    value: function renderFooter() {
      var _this$props2 = this.props,
          renderFooter = _this$props2.renderFooter,
          value = _this$props2.value;
      if (!(renderFooter && typeof renderFooter === 'function')) return null;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          key: "footer",
          className: inputClass('footer')
        }, renderFooter(value))
      );
    }
  }, {
    key: "renderInfo",
    value: function renderInfo() {
      var info = this.props.info;
      var notNumber = typeof info !== 'number';
      if (typeof info !== 'function' && notNumber) return null;
      var textInfo = notNumber ? info : this.defaultInfo;
      var res = textInfo(this.props.value); // empty

      if (!res) return null;
      var isError = res instanceof Error;
      var text = isError ? res.message : res;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          key: "info",
          style: {
            minWidth: 'auto'
          },
          className: inputClass(isRTL() ? 'bottom-left' : 'bottom-right', isError ? 'error' : 'tip')
        }, text)
      );
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          autosize = _this$props3.autosize,
          onChange = _this$props3.onChange,
          maxHeight = _this$props3.maxHeight,
          info = _this$props3.info,
          onEnterPress = _this$props3.onEnterPress,
          resize = _this$props3.resize,
          renderFooter = _this$props3.renderFooter,
          inputFocus = _this$props3.inputFocus,
          innerTitle = _this$props3.innerTitle,
          placeTitle = _this$props3.placeTitle,
          props = _objectWithoutProperties(_this$props3, ["autosize", "onChange", "maxHeight", "info", "onEnterPress", "resize", "renderFooter", "inputFocus", "innerTitle", "placeTitle"]);

      var value = props.value == null ? '' : props.value;
      var height = this.state.height || 'auto';
      var footerEl = this.renderFooter();
      var className = autosize ? inputClass('auto-size') : inputClass(resize && 'textarea-resize');
      var cs = classnames(className, innerTitle && inputTitleClass('hidable', 'item'));
      var ts = [
      /*#__PURE__*/
      React.createElement("textarea", Object.assign({}, cleanProps(props), {
        key: "t",
        value: value,
        className: cs,
        style: {
          height: height,
          maxHeight: maxHeight,
          overflow: 'auto'
        },
        onChange: this.handleChange,
        onKeyUp: this.handleKeyUp,
        onBlur: this.handleBlur
      })), footerEl, this.renderInfo()];
      var cs2 = classnames(inputClass('shadow'), innerTitle && inputTitleClass('hidable', 'item'));

      if (autosize) {
        ts.push(
        /*#__PURE__*/
        React.createElement("textarea", {
          key: "s",
          ref: this.bindShadow,
          className: cs2,
          rows: props.rows,
          defaultValue: value
        }));
      }

      return (
        /*#__PURE__*/
        React.createElement(InputTitle, {
          innerTitle: innerTitle,
          open: !!value || !!inputFocus,
          placeTitle: placeTitle
        }, ts)
      );
    }
  }]);

  return Textarea;
}(PureComponent);

Textarea.defaultProps = DefaultProps;
export default Textarea;